import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class TaldezainaTask extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "matchId", Model.attribute('matchId'));
    _defineProperty(this, "taskKey", Model.attribute('taskKey'));
    _defineProperty(this, "title", Model.attribute('title'));
    _defineProperty(this, "description", Model.attribute('description'));
    _defineProperty(this, "actionUrl", Model.attribute('actionUrl'));
    _defineProperty(this, "status", Model.attribute('status'));
    _defineProperty(this, "isManual", Model.attribute('isManual'));
    _defineProperty(this, "createdByUserId", Model.attribute('createdByUserId'));
    _defineProperty(this, "completedByUserId", Model.attribute('completedByUserId'));
    _defineProperty(this, "completedAt", Model.attribute('completedAt', Model.transformDate));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "updatedAt", Model.attribute('updatedAt', Model.transformDate));
    _defineProperty(this, "match", Model.hasOne('match'));
    _defineProperty(this, "creator", Model.hasOne('creator'));
    _defineProperty(this, "completer", Model.hasOne('completer'));
  }
}
flarum.reg.add('nagusi-match-ratings', 'common/models/TaldezainaTask', TaldezainaTask);